"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const victory_create_container_1 = require("victory-create-container");
const ChartLabel_1 = require("../ChartLabel");
const ChartTooltip_1 = require("../ChartTooltip");
const chart_tooltip_1 = require("./chart-tooltip");
/**
 * Makes a container component with multiple behaviors. It allows you to effectively combine any two
 * containers of type 'brush', 'cursor', 'selection', 'voronoi', or 'zoom'. Default container props are applied to
 * support the PatternFly theme.
 *
 * Each behavior must be one of the following strings: 'brush', 'cursor', 'selection', 'voronoi', and 'zoom'. The
 * resulting container uses the events from both behaviors. For example, if both behaviors use the click event (like
 * zoom and selection) the combined container will trigger both behaviors' events on each click.
 *
 * Note: Order of the behaviors matters in a few cases. It is recommended to use 'zoom' before any other behaviors: for
 * example, createContainer('zoom', 'voronoi') instead of createContainer('voronoi', 'zoom').
 *
 * See https://formidable.com/open-source/victory/docs/create-container
 *
 * @param {string} behaviorA 'brush', 'cursor', 'selection', 'voronoi', or 'zoom'
 * @param {string} behaviorB 'brush', 'cursor', 'selection', 'voronoi', or 'zoom'
 */
exports.createContainer = (behaviorA, behaviorB) => {
    const container = victory_create_container_1.createContainer(behaviorA, behaviorB);
    const isCursor = behaviorA === 'cursor' || behaviorB === 'cursor';
    const isVoronoi = behaviorA === 'voronoi' || behaviorB === 'voronoi';
    if (isCursor) {
        container.defaultProps.cursorLabelComponent = React.createElement(ChartLabel_1.ChartLabel, null);
    }
    if (isVoronoi) {
        const labelTextAnchor = isCursor ? 'start' : undefined; // Left align tooltip text
        const centerOffset = isCursor ? chart_tooltip_1.getTooltipCenterOffset(true) : undefined;
        container.defaultProps.labelComponent = (React.createElement(ChartTooltip_1.ChartTooltip, { labelTextAnchor: labelTextAnchor, centerOffset: centerOffset }));
    }
    return container;
};
//# sourceMappingURL=chart-container.js.map